var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-row',{staticClass:"mt-8",attrs:{"title":"Type","no_border":true}},[_c('input-text',{staticClass:"flex-1",attrs:{"value":_vm.insurance.insurance_type,"name":"insurance_type","read_only":_vm.read_only}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }